<template>
  <div class="form">
    <h1 class="extra-large-headline">{{ formTitle }}</h1>
    <p class="bodycopy">
      {{ formDescription }}
    </p>
    <form @submit.prevent>
      <component
        :is="loadDynamicFormPath"
        @payment-complete="handleFormRedirect"
        @payment-failed="handleFailureRedirect"
      />
    </form>
  </div>
</template>

<script setup>
import {
  ref,
  defineAsyncComponent,
  computed,
  onMounted,
} from 'vue';
import { useRouter } from "vue-router";
import { useI18n } from 'vue-i18n';

import { useGlobalStore } from "@/stores/globalStore";
import { useOrderFormStore } from "@/stores/forms/orderFormStore";

import { capitaliseFirstChar } from "@/composables/helpers/useStringHelpers.js";

import useRedirectPayments from '@/composables/payments/useRedirectPayment';

const orderStore = useOrderFormStore();
const globalStore = useGlobalStore();
const { handleFailureRedirect } = useRedirectPayments();

const router = useRouter();
const form = ref({
  payment: orderStore.getPaymentProvider?.paymentType,
});
const { t } = useI18n();

const loadDynamicFormPath = computed(() => {
  const payment = capitaliseFirstChar(form.value.payment.toLowerCase());
  return defineAsyncComponent(() =>
    import(/* @vite-ignore */ `./Payments/${payment}/${payment}Form.vue`)
  );
});

const formTitle = computed(() => {
  return orderStore.isBuyMode || orderStore.isNFTMode ? t('PaymentForm.label.paymentDetails') : t('PaymentForm.label.depositDetails');
})

const formDescription = computed(() => {
  return orderStore.isBuyMode || orderStore.isNFTMode ? t('PaymentForm.label.instruction') : '';
})

const handleFormRedirect = (orderId, isPaymentComplete = false) => {
  globalStore.setPaymentStatus(isPaymentComplete);
  if (orderStore.getOrderType === "CRYPTO-SELL") {
    router.push(`/coindeposit/${orderId}`);
    return;
  }
  if (orderStore.getOrderType === "NFT-BUY") {
    router.push(`/nft/status/${orderId}`);
    return;
  }
  router.push(`/status/${orderId}`);
};

onMounted(() => {
  globalStore.setPaymentStatus(false);
});
</script>
<style lang="scss"></style>
